<template>
	<SignUpPageBase :content="this">
		<h4 class="font_lg font_bold margin_title_bottom">{{ $t("signUp.masterUser.title") }}</h4>
		<form class="flex flex_center flex_column w_100">
			<!-- User -->
			<md-field :class="[{ 'md-error': errors.has('userFirstName') }]">
				<label>{{ $t("common.firstName") }}</label>
				<md-input
					v-model="form.userFirstName"
					v-validate="modelValidations.userFirstName"
					data-vv-name="userFirstName"
					autocomplete="given-name"
					required
				></md-input>
			</md-field>
			<md-field :class="[{ 'md-error': errors.has('userLastName') }]">
				<label>{{ $t("common.lastName") }}</label>
				<md-input
					v-model="form.userLastName"
					v-validate="modelValidations.userLastName"
					data-vv-name="userLastName"
					autocomplete="family-name"
					required
				></md-input>
			</md-field>
			<md-field :class="[{ 'md-error': errors.has('userEmail') }]">
				<label>{{ $t("common.email") }}</label>
				<md-input
					v-model="form.userEmail"
					v-validate="modelValidations.userEmail"
					data-vv-name="userEmail"
					type="email"
					autocomplete="email"
					required
				></md-input>
			</md-field>
			<md-field :class="[{ 'md-error': errors.has('userPhone') }]">
				<label>{{ $t("common.phone") }}</label>
				<md-input
          ref="phoneImp"
          @click="addPlaceholder"
          @blur="dropPlaceholder"
          @input="onChange"
					v-model="form.userPhone"
					v-validate="modelValidations.userPhone"
					data-vv-name="userPhone"
					autocomplete="tel"
          placeholder=""
					required
				></md-input>
			</md-field>
			<md-field :class="[{ 'md-error': errors.has('userPosition') }]">
				<label>{{ $t("common.positionInCompany") }}</label>
				<md-input
					v-model="form.userPosition"
					v-validate="modelValidations.userPosition"
					data-vv-name="userPosition"
					autocomplete="organization-title"
					required
				></md-input>
			</md-field>
			<!-- Conditions -->
			<div class="w_100">
				<div class="flex flex_start" style="align-items:start">
					<md-checkbox
						:class="[{ 'md-error': errors.has('termsOfServiceCheck') }]"
						v-model="form.termsOfServiceCheck"
						v-validate="modelValidations.termsOfServiceCheck"
						data-vv-name="termsOfServiceCheck"
						required
						style="margin-top: 4px"
					></md-checkbox>
					<div>
						<span>{{ $t("signUp.conditions.termsOfService.text") }}</span>
						&nbsp;
						<a class="pointer" @click="showTermsAndConditions">
							<span>{{$t("signUp.conditions.termsOfService.link") }}</span>
						</a>
						<TermsAndConditionsDisplay ref="tosDisplay"></TermsAndConditionsDisplay>
						<template v-if="signUpData.invitationCode && termsOfPartnerExists">
							<span>{{$t("signUp.conditions.termsOfPartner.text")}}</span>
							<a :href="termsOfPartnerUrl" target="_blank">
								<span>{{$t("signUp.conditions.termsOfPartner.link") }}</span>
							</a>
						</template>

						<span>{{ $t("signUp.conditions.policies.text1") }} </span>
						<a :href="privacyPolicyUrl" target="_blank">
							<span>{{$t("signUp.conditions.policies.link1") }}</span>
						</a>
						&nbsp;
						<span>{{ $t("signUp.conditions.policies.text2") }} </span>

						<a :href="cookiePolicyUrl" target="_blank">
							<span>{{ $t("signUp.conditions.policies.link2") }}</span>
						</a>
						<span>{{ $t('signUp.conditions.policies.text3') }}</span>
					</div>
				</div>

			</div>
		</form>
	</SignUpPageBase>
</template>


<script>
import SignUpPageBase from "@/views/register/SignUpPageBase";
import {enumDef} from "@/common/enumDefs";
import TermsAndConditionsDisplay from "@/components/templates/common/TermsAndConditionsDisplay";
import {mapGetters} from "vuex";
import APP from "@/common/appConfig";
import {registrationApi} from "@/common/api/registrationApi";

export default {
	components: {
		TermsAndConditionsDisplay,
		SignUpPageBase,
	},
	data() {
		return {
			form: {
				userFirstName: "",
				userLastName: "",
				userPhone: "",
				userPosition: "",
				userEmail: "",
				termsOfServiceCheck: false,
			},
			modelValidations: {
				userFirstName: {
					required: true
				},
				userLastName: {
					required: true
				},
				userPhone: {
          regex: "^([+][0-9 ]+)$",
					required: true
				},
				userPosition: {
					required: true
				},
				userEmail: {
					required: true,
					email: true
				},
				userPassword: {
					required: true
				},
				termsOfServiceCheck: {
					checked: true
				},
			},
			privacyPolicyUrl: null,
			cookiePolicyUrl: null,
			termsOfPartnerUrl: null,
			termsOfPartnerExists: false
		};
	},
	created() {
		this.$mergeOnlyExistingProps(this.form, this.signUpData, true);
		let isGerman = this.signUpData.language == enumDef.language.DE;
		this.privacyPolicyUrl = isGerman ? `https://walbing.com/de/datenschutz/` : `https://walbing.com/privacy-policy/`;
		this.cookiePolicyUrl = isGerman ? `https://walbing.com/de/cookie-richtlinie/` : `https://walbing.com/cookie-policy/`;
		if (this.signUpData.invitationCode) {
			this.termsOfPartnerUrl = APP.DOMAIN + registrationApi.buildTermsOfPartnerUrl(this.signUpData.invitationCode);
			registrationApi.isTermsOfPartnerAvailable(this.signUpData.invitationCode).then((result => {
				this.termsOfPartnerExists = result;
			})).catch(this.toast)
		}
	},
	computed: {
		...mapGetters({
			signUpData: "local/signUpData",
		})
	},
	methods: {
		showTermsAndConditions() {
			this.$refs.tosDisplay.show();
		},
    onChange() {
      if (this.form.userPhone && !this.form.userPhone.startsWith("+")) {
        this.form.userPhone = '+' + this.form.userPhone;
      }
    },
    addPlaceholder() {
      this.$refs.phoneImp.placeholder = this.$t("common.phone.placeholder");
    },
    dropPlaceholder() {
      this.$refs.phoneImp.placeholder = "";
    },
	}
};
</script>
